import { currentStartOf } from '@orgus/protocol';
import type { Session } from '@orgus/protocol';

/**
 * Whether a session's clock runs: only while it works or waits on someone. An idle session is
 * open but doing nothing (a headless run that finished keeps its process for follow-up
 * messages), so its time stops at its last activity, as an ended one's does.
 */
export const sessionTicking = (s: Pick<Session, 'status'>): boolean => s.status === 'working' || s.status === 'waiting';

/**
 * How long a session has run (ticking) or ran (idle or ended: up to its last activity), from its
 * current start: the latest launch or wake (ORGU-132), so a session woken several times is not
 * one long run. Its first start is a fact of its own (SessionFacts).
 */
export function sessionRanMs(s: Pick<Session, 'status' | 'startedAt' | 'lastActivity'> & Partial<Pick<Session, 'ext'>>, now: number): number {
  return Math.max(0, (sessionTicking(s) ? now : s.lastActivity) - currentStartOf(s));
}
